import { PageLayout } from "@/shared/components";
import { EventsList } from "@/shared/components/events";

export function EventsPage() {
  return (
    <PageLayout title="Roboto - Events" headerContentLeft="Events">
      <EventsList />
    </PageLayout>
  );
}
